import { useEffect, useMemo, useState } from "react";
import { Container, Stack, Paper, Button } from "@mui/material";
import {
  CardAll,
  ConditionalRenderer,
  DataDisplayMessage,
  Filters,
  Header,
  TabsFilters,
  useLanguageTranslator,
} from "../../../components";
import { usePublicPracticesCall } from "../../../hooks";

function PracticesList() {
  const [inputValue, setInputValue] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({
    country: "",
    startYear: null,
    endYear: null,
    theme: "",
  });
  const [currTabIndex, setCurrTabIndex] = useState("all");
  const [limit, setLimit] = useState(8);

  const { translator } = useLanguageTranslator();

  const { practices, tabs, loading, metadata }: any = usePublicPracticesCall({
    variables: {
      limit: limit,
      ...(filters?.country && filters?.country !== "0"
        ? { countryId: Number(filters?.country) }
        : {}),
      ...(filters?.theme && filters?.theme !== "0"
        ? { themeId: Number(filters?.theme) }
        : {}),
      ...(filters?.startYear ? { startYear: Number(filters?.startYear) } : {}),
      ...(filters?.endYear ? { endYear: Number(filters?.endYear) } : {}),
    },
    currTabIndex: currTabIndex,
    totalCountItems: totalCount,
  });

  useEffect(() => {
    if (metadata?.totalCount) {
      setTotalCount(metadata?.totalCount);
    }
  }, [metadata]);

  function onClickHandler() {
    const scrollPosition = window.scrollY;
    setLimit(limit + 8);

    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    }, 0);
  }

  const hasMore =
    limit === metadata?.totalCount ||
    limit > metadata?.totalCount ||
    !metadata?.totalCount;

  const filteredPracticesList = useMemo(() => {
    if (!inputValue) return practices || [];

    const searchValue = inputValue
      ?.normalize("NFD")
      ?.replace(/[\u0300-\u036f]/g, "")
      ?.toLowerCase();

    return practices?.filter((item: any) =>
      item?.title
        ?.normalize("NFD")
        ?.replace(/[\u0300-\u036f]/g, "")
        ?.toLowerCase()
        ?.includes(searchValue)
    );
  }, [inputValue, practices]);

  return (
    <div>
      <Header
        title={translator("Practices")}
        subtitle=""
        setInputValue={setInputValue}
        inputValue={inputValue}
      />
      <Filters setFilters={setFilters} filters={filters} />

      <Container sx={{ my: 3 }}>
        <TabsFilters
          currTab={currTabIndex}
          setCurrTab={setCurrTabIndex}
          listItems={tabs}
          heading={`${translator("List of")} ${translator("Practices")}`}
          isAllShow={true}
        />

        <Stack gap={2}>
          {filteredPracticesList?.map((p: any, i: any) => (
            <CardAll
              key={`practice-list-card-${i}`}
              p={p}
              loading={loading}
              path={`/practices/${p.id}`}
            />
          ))}
          <DataDisplayMessage data={filteredPracticesList} loading={loading} />
        </Stack>
      </Container>

      <ConditionalRenderer condition={!hasMore}>
        <Container sx={{ my: 3 }}>
          <Paper sx={{ py: 2, display: "flex", justifyContent: "center" }}>
            <Button onClick={onClickHandler}>{translator("Show more")}</Button>
          </Paper>
        </Container>
      </ConditionalRenderer>
    </div>
  );
}

export { PracticesList };
